import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import useLoadScripts from '../utils/useLoadScript';
import { MetaTagComponent, MetaTags } from '../utils/MetaTags';

function TermsPage() {
  useLoadScripts([
    '/assets/js/jquery-3.7.1.min.js',
    '/assets/js/jquery-ui.js',
    '/assets/js/moment.min.js',
    '/assets/js/bootstrap.min.js',
    '/assets/js/swiper-bundle.min.js',
    '/assets/js/waypoints.js',
    '/assets/js/jquery.counterup.min.js',
    '/assets/js/wow.min.js',
    '/assets/js/jquery.nice-select.min.js',
    '/assets/js/jquery.marquee.min.js',
    '/assets/js/gsap.min.js',
    '/assets/js/ScrollTrigger.min.js',
    '/assets/js/ScrollSmoother.min.js',
    '/assets/js/SplitText.min.js',
    '/assets/js/jquery.fancybox.min.js',
    '/assets/js/three.js',
    '/assets/js/hover-effect.umd.js',
    '/assets/js/custom.js',
  ]);

  // Premium Styles (Matching Privacy Page)
  const containerStyle = {
    maxWidth: "900px",
    margin: "120px auto",
    padding: "60px",
    fontFamily: "'Inter', 'Poppins', sans-serif",
    backgroundColor: "#ffffff",
    borderRadius: "24px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.04)",
    border: "1px solid #f0f0f0",
  };

  const sectionStyle = {
    marginBottom: "40px",
    paddingBottom: "20px",
    borderBottom: "1px solid #f9f9f9",
  };

  const headingStyle = {
    fontSize: "42px",
    fontWeight: "700",
    letterSpacing: "-1px",
    marginBottom: "20px",
    color: "#111",
    textAlign: "center"
  };

  const subHeadingStyle = {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "16px",
    color: "#1a1a1a",
  };

  const textStyle = {
    fontSize: "16px",
    lineHeight: "1.8",
    color: "#4b5563",
    fontWeight: "400",
  };

  const listStyle = {
    ...textStyle,
    paddingLeft: "25px",
    marginTop: "10px",
  };

  const badgeStyle = {
    display: "inline-block",
    padding: "6px 16px",
    backgroundColor: "#e0f2fe", // Light blue tint
    borderRadius: "50px",
    fontSize: "13px",
    fontWeight: "600",
    color: "#0369a1",
    marginBottom: "20px",
    textTransform: "uppercase",
    letterSpacing: "1px"
  };

  return (
    <div id="smooth-wrapper">
      <div id="smooth-content">
        <MetaTagComponent 
          pageTitle={MetaTags.terms.title}
          pageDescription={MetaTags.terms.description}
          pageKeywords={MetaTags.terms.keywords}
        />
        <Header />

        <main style={{ backgroundColor: "#fafafa", overflow: "hidden", padding: "20px" }}>
          <div style={containerStyle} className="wow fadeInUp" data-wow-delay="0.2s">
            
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
              <span style={badgeStyle}>User Agreement</span>
              <h1 style={headingStyle}>Terms & Conditions</h1>
              <p style={{ ...textStyle, fontSize: "18px", color: "#9ca3af" }}>
                Last Updated: April 2026
              </p>
            </div>

            <div style={sectionStyle}>
              <p style={textStyle}>
                Welcome to <strong>Insight Wide</strong>. By accessing our platform, website, or services, 
                you agree to be bound by these Terms and Conditions. Please read them carefully to 
                understand your rights and obligations.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>1. Use of Services</h2>
              <p style={textStyle}>
                You agree to use Insight Wide services only for lawful purposes. You must not use our 
                platform in any way that causes damage to the website or impairs the accessibility of 
                the service for other users.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>2. Account Responsibility</h2>
              <p style={textStyle}>
                If you create an account on Insight Wide, you are responsible for maintaining the 
                confidentiality of your login credentials. Any activity performed under your account 
                will be considered your responsibility.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>3. Intellectual Property</h2>
              <p style={textStyle}>
                All content, logos, graphics, and software code on Insight Wide are the exclusive 
                property of Insight Wide and are protected by international copyright laws. Unauthorized 
                reproduction is strictly prohibited.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>4. Subscription & Payments</h2>
              <ul style={listStyle}>
                <li style={{ marginBottom: "8px" }}>Payments are processed securely through our partners.</li>
                <li style={{ marginBottom: "8px" }}>Subscription fees are non-refundable unless specified otherwise.</li>
                <li style={{ marginBottom: "8px" }}>We reserve the right to modify pricing with prior notice.</li>
              </ul>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>5. Limitation of Liability</h2>
              <p style={textStyle}>
                Insight Wide provides the platform "as is." We do not guarantee that the service will be 
                uninterrupted or error-free. We shall not be liable for any indirect, incidental, or 
                consequential damages resulting from the use of our tools.
              </p>
            </div>

            <div style={sectionStyle}>
              <h2 style={subHeadingStyle}>6. Termination</h2>
              <p style={textStyle}>
                We reserve the right to suspend or terminate your access to our services at any time, 
                without notice, for conduct that we believe violates these Terms or is harmful to 
                other users or business interests.
              </p>
            </div>

            <div style={{ ...sectionStyle, borderBottom: "none", marginBottom: 0 }}>
              <h2 style={subHeadingStyle}>Contact Legal</h2>
              <p style={textStyle}>
                Questions regarding our Terms and Conditions should be directed to the 
                <strong> Insight Wide Legal Department</strong> via our official support email.
              </p>
            </div>

          </div>
        </main>

        <Footer />
      </div>
    </div>
  );
}

export default TermsPage;